<template>
  <div>
    <!-- confirmation Modal  -->
    <b-modal
      id="confirmModal"
      scrollable
      hide-header
      hide-footer
      no-close-on-esc
      ref="confirmModal"
    >
      <div class="content-cont">
        <p class="header-title">{{ $t("addExpectedVisitor.addVisit") }}</p>
        <div class="hint-modal">
          {{ $t("common.notes.areYouSureYouWant")
          }}<b>"{{ $t("common.add") }}"</b>
          {{ $t("addExpectedVisitor.aVisitFor") }} {{ fullName }}
          {{ $t("addExpectedVisitor.in") }} "{{ siteName }} - {{ areaName }}"
          {{ $t("addExpectedVisitor.asA") }} "{{ userTypeName }}" {{ $t('addExpectedVisitor.on') }}
          {{ visitDateWithSpecificFormat }} {{ $t('addExpectedVisitor.at') }}
          {{ visitTimeWithSpecificFormat }} {{ hostFullName }} {{ $t('common.questionMark') }}
        </div>
        <!-- action btns  -->
        <hr class="h-line" />
        <div class="action-btns">
          <button
            :disabled="confirmAddVisitor"
            class="start-btn btn btn-primary"
            @click="onSubmit()"
            size="md"
          >
            {{ $t('common.confirm') }}<i
              v-if="confirmAddVisitor"
              style="margin-inline-start: 5px"
              class="bx bx-loader bx-spin font-size-16 align-middle rounded"
            ></i>
          </button>
          <button
            class="btn cancel-btn"
            type="button"
            @click="$bvModal.hide('confirmModal')"
          >
            {{ $t('common.cancel') }}
          </button>
        </div>
      </div>
    </b-modal>

    <VpFormLayout>
      <template v-slot:content-header>
        <PageHeader className="d-flex align-items-center " :title="title" />
      </template>
      <template v-slot:content-body>
        <section>
          <b-form id="form" class="form-horizontal" @submit.prevent="onSubmit">
            <div class="expected-visitors-section">
              <div class="expected-visitors-container">
                <!-- <div class="visit-type-action  d-flex"> 
                                <b-button @click="toggleSingleOrMultipleVisits('single')" :disabled="singleVisit.disabled" 
                                pill class="d-flex align-items-center single-visit" variant="primary" size="sm">
                                    Single Visit
                                </b-button>

                                <b-button  @click="toggleSingleOrMultipleVisits('multiple')" :disabled="multipleVisits.disabled"
                                pill class="d-flex align-items-center multiple-visit " variant="primary" size="sm">
                                    Multiple Visits       
                                </b-button>
                            </div>
                            <div class="seperator-line"></div> -->
                <div class="add-visitor-form">
                  <h6 class="visit-details">
                    {{ $t("common.site") }} {{ $t("common.&") }} {{ $t("common.area") }}
                  </h6>
                  <div class="d-flex sites-areas-selection">
                    <VpMultiselect
                      class="mr-32"
                      zIndex="120"
                      :showPlaceholderIcon="true"
                      width="416"
                      :isLoading="sitesLoading"
                      :showOptionsBorder="true"
                      :showNoResults="true"
                      v-model="form.site"
                      label="name"
                      :options="sitesAndAreasByEntityId"
                      :allowEmpty="true"
                      :show-labels="false"
                      :title="$t('common.site')"
                      :disabled="!sitesAndAreasByEntityId.length"
                      :noResultMessage="$t('common.noResults')"
                      @input="changeSiteValue"
                    />

                    <div class="area-select">
                      <VpTreeselect
                        zIndex="100"
                        :showPlaceholderIcon="true"
                        width="416"
                        :showOptionsBorder="true"
                        :showNoResults="true"
                        v-model="form.area"
                        :isLoading="areasLoading"
                        :options="areasOptions"
                        :allowEmpty="true"
                        :show-labels="true"
                        :isMultiple="false"
                        :label="$t('common.area')"
                        dropDownStyle="absolute"
                        :disabled="!form.site"
                        :noResultMessage="$t('common.noResults')"
                        @input="changeAreaValue"
                        :errMsg="
                          areaHasUserTypesToAddVisitor
                            ? $t(
                                'addExpectedVisitor.noUsersCanBeAddedExpectedVisitors'
                              )
                            : ''
                        "
                      />

                      <div
                        v-if="
                          showAreaPreRegistrationUrl &&
                          !areaHasUserTypesToAddVisitor
                        "
                        class="pre-registration-url-hint"
                      >
                        <span
                          ><b>{{ $t("common.notes.note") }}:</b></span
                        >
                        <span>
                          {{ $t("addExpectedVisitor.fillInTheDetailsBelow") }}
                          <span class="router-color">
                            <a
                              class="pointer"
                              target="_blank"
                              :href="preRegistrationUrl"
                            >
                              {{ preRegistrationUrl }}
                            </a></span
                          >
                          {{
                            $t(
                              "addExpectedVisitor.toYourVisitorsPreRegisterVisits"
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="seperator-line"></div>
                  <h6 class="visit-details">
                    {{ $t("addExpectedVisitor.visitorDetails") }}
                  </h6>
                  <div v-if="singleVisit.showUserSection" class="single-visit">
                    <div class="select-user d-flex">
                      <VpMultiselect
                        zIndex="110"
                        :showPlaceholderIcon="true"
                        width="416"
                        :isLoading="userLoading"
                        :showOptionsBorder="true"
                        :showNoResults="true"
                        v-model="form.user"
                        :label="userSearchLabel"
                        :options="usersOptions"
                        :allowEmpty="true"
                        :show-labels="false"
                        :searchable="true"
                        :placeholder="
                          $t('addExpectedVisitor.searchByNamePhoneNumberEmail')
                        "
                        :disabled="!form.area || areaHasUserTypesToAddVisitor"
                        :noResultMessage="$t('common.noResults')"
                        @searchChange="searchByUserName"
                        @input="changeUserValue"
                        @close="checkUsersValidations"
                        :errMsg="
                          !haveUsersToSelectHost &&
                          !allowWithoutHost &&
                          addHost &&
                          form.user
                            ? $t(
                                'addExpectedVisitor.noUsersAvailableSelectedAsHost'
                              )
                            : ''
                        "
                      />
                    </div>

                    <div class="new-user" v-show="addNewUser">
                      <div
                        class="first-last-name-wrapper"
                        style="margin-bottom: 17px"
                      >
                        <div class="d-flex align-items-center">
                          <!-- first name  -->
                          <div
                            class="mr-32"
                            :class="
                              $v.newUser.first_name.$error && 'invalid-value'
                            "
                          >
                            <VpInput
                              maxlength="20"
                              v-model="newUser.first_name"
                              type="text"
                              width="416"
                              :label="$t('common.firstName')"
                              :class="{
                                'not-allowed-cursor': newUser.last_name >= 20,
                              }"
                            />
                          </div>

                          <!-- last name  -->
                          <div
                            :class="
                              $v.newUser.last_name.$error && 'invalid-value'
                            "
                          >
                            <VpInput
                              maxlength="20"
                              v-model.trim="newUser.last_name"
                              :class="{
                                'not-allowed-cursor': newUser.last_name >= 20,
                              }"
                              type="text"
                              width="416"
                              :label="$t('common.lastName')"
                            />
                          </div>
                        </div>
                      </div>

                      <!-- register user type and email  -->
                      <div
                        class="register-email-phone d-flex"
                        style="margin-bottom: 17px"
                      >
                        <div class="mr-32">
                          <VpTreeselect
                            zIndex="100"
                            class="user-type-select"
                            :showPlaceholderIcon="true"
                            width="416"
                            :showOptionsBorder="true"
                            :showNoResults="true"
                            v-model="newUser.user_type"
                            :isLoading="userTypeLoading"
                            :options="userTypesOptions"
                            :allowEmpty="true"
                            :show-labels="true"
                            :isMultiple="false"
                            :label="$t('common.userType')"
                            dropDownStyle="absolute"
                            :disabled="
                              !userTypesOptions.length || userTypeLoading
                            "
                            :noResultMessage="$t('common.noResults')"
                            @input="changeUserType"
                            :errMsg="
                              !haveUsersToSelectHost &&
                              !allowWithoutHost &&
                              addHost
                                ? $t(
                                    'addExpectedVisitor.noUsersAvailableSelectedAsHost'
                                  )
                                : ''
                            "
                          />
                        </div>

                        <!-- email   -->
                        <div class="company-email" style="width: 416px">
                          <VpInput
                            :isLoading="emailLoading"
                            :class="{
                              'vp-mb-20':
                                !$v.newUser.email.email || emailValidation,
                            }"
                            v-model.trim="newUser.email"
                            type="text"
                            width="416"
                            :label="$t('common.emailAddressOptional')"
                            @input="checkDuplicatedEmailOrPhone('email')"
                            :invalid="
                              !$v.newUser.email.email || emailValidation
                            "
                            :errMsg="
                              !$v.newUser.email.email
                                ? $t('common.notes.enterValidEmailMessage')
                                : emailValidation
                                ? $t('common.notes.emailAddressAlreadyExists')
                                : ''
                            "
                          />
                        </div>
                      </div>

                      <!-- register phone  -->
                      <div
                        class="input-wrapper current-phone"
                        style="margin-bottom: 17px"
                      >
                        <div class="d-flex">
                          <div>
                            <div class="row-group phone-group mr-32">
                              <VueCountryCode
                                class="country-code-input"
                                :class="
                                  phoneValidation
                                    ? 'is-invalidSecond invalid-date-input'
                                    : ''
                                "
                                :disabledFetchingCountry="false"
                                :enabledCountryCode="true"
                                :preferredCountries="['GB', 'US', 'CN']"
                                @onSelect="onSelectUserCountryCode"
                              />

                              <VpInput
                                v-model.trim="newUser.phone"
                                type="number"
                                :isLoading="phoneLoading"
                                width="290"
                                :label="$t('common.phoneNumberOptional')"
                                @input="checkDuplicatedEmailOrPhone('phone')"
                                :invalid="
                                  !$v.newUser.phone.numeric || phoneValidation
                                "
                              />

                              <!-- </div> -->
                            </div>
                          </div>
                        </div>
                        <div
                          class="err-wrapper"
                          style="
                            margin-inline-start: 16px !important;
                            padding-top: 10px;
                          "
                        >
                          <div v-if="phoneValidation">
                            <span class="error-value">
                              {{ $t("common.notes.phoneNumberAlreadyExists") }}
                            </span>
                          </div>
                          <div v-if="!$v.newUser.phone.numeric">
                            <span class="error-value">
                              {{ $t("common.notes.phoneNumberOnlyDigits") }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="customSections.length"
                    class="visits-custom-fields vp-mt-32"
                  >
                    <div
                      v-for="(section, index) in customSections"
                      :key="index"
                    >
                      <RenderFieldType
                        class="w-100"
                        :addSeperator="false"
                        :section="section"
                        :isAddVisit="true"
                        @updateCustomField="updateCustomField"
                      />
                    </div>
                  </div>

                  <div class="seperator-line"></div>

                  <h6 class="visit-details">
                    {{ $t("addExpectedVisitor.visitDateAndTime") }}
                  </h6>
                  <h6 class="visit-date">
                    {{ $t("addExpectedVisitor.visitDate") }}
                  </h6>
                  <div
                    class="d-flex custom-radio-group custom-radio"
                    :class="
                      !form.site && !form.area ? 'disabled-date-time' : ''
                    "
                  >
                    <v-radio-group
                      :class="visitDateValidation ? 'date-err' : ''"
                      v-model="form.dateStringValue"
                      @change="changeVisitDate($event)"
                      :disabled="form.site && form.area ? false : true"
                    >
                      <v-radio
                        :color="
                          visitDateValidation ||
                          (isVisitError && form.dateStringValue == 'today')
                            ? '#F46A6A'
                            : ''
                        "
                        :label="$t('common.today')"
                        :value="'today'"
                      ></v-radio>
                      <v-radio
                        :color="
                          visitDateValidation ||
                          (isVisitError && form.dateStringValue == 'tomorrow')
                            ? '#F46A6A'
                            : ''
                        "
                        :label="$t('common.tomorrow')"
                        :value="'tomorrow'"
                      ></v-radio>
                      <div class="custom-line"></div>
                      <v-radio
                        :color="
                          visitDateValidation ||
                          (isVisitError && form.dateStringValue == 'customDate')
                            ? '#F46A6A'
                            : ''
                        "
                        :label="$t('common.customDate')"
                        :value="'customDate'"
                      ></v-radio>
                    </v-radio-group>

                    <div class="d-flex">
                      <div style="margin-inline-start: 24px">
                        <date-picker
                          :disabled="dateValue"
                          class="pre-reg-datepicker"
                          :first-day-of-week="1"
                          @input="changeVisitDateValidation"
                          value-type="date"
                          v-model="form.dateInputValue"
                          format="DD/MM/Y"
                          :placeholder="$t('addExpectedVisitor.visitDate')"
                          :disabledDate="disableDateBeforeCurrent"
                          :class="
                            (visitDateValidation && form.dateInputValue) ||
                            (isVisitError &&
                              form.dateStringValue == 'customDate')
                              ? ' is-invalid invalid-date-input'
                              : ''
                          "
                        >
                          <i slot="icon-calendar">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                                :fill="
                                  form.dateInputValue ? '#103F5E' : '#787878'
                                "
                              />
                            </svg>
                          </i>
                        </date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="err-wrapper">
                    <div v-if="isVisitError" class="visit-error-message">
                      <span
                        class="error-value"
                        v-text="visitErrorMessage"
                      ></span>
                    </div>
                  </div>
                  <div class="err-wrapper-two">
                    <div v-if="visitDateValidation" class="visit-error-message">
                      <span class="error-value-two">{{
                        $t("addExpectedVisitor.visitDateCantBeforeToday")
                      }}</span>
                    </div>
                  </div>
                  <h6 class="visit-time">
                    {{ $t("addExpectedVisitor.visitTime") }}
                  </h6>
                  <date-picker
                    :disabled="
                      form.site && form.area && form.dateStringValue
                        ? false
                        : true
                    "
                    id="visit_time"
                    class="pre-reg-datepicker"
                    :class="
                      visitTimeValidation ? 'is-invalid invalid-date-input' : ''
                    "
                    :use12h="true"
                    :show-second="false"
                    format="hh:mm A"
                    value-type="date"
                    type="time"
                    :placeholder="$t('addExpectedVisitor.visitTime')"
                    v-model="form.timeInputValue"
                    :default-value="defaultTimeWithTimezone"
                    @input="changeVisitTimeValidation"
                  >
                    <i slot="icon-calendar">
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                          :fill="form.timeInputValue ? '#103F5E' : '#787878'"
                        />
                      </svg>
                    </i>
                  </date-picker>
                  <div
                    v-if="visitTimeValidation"
                    class="err-wrapper visit-time-error"
                  >
                    <div
                      class="visit-error-message"
                      style="
                        margin-top: 12px;
                        margin-inline-start: 20px;
                        width: 182px;
                      "
                    >
                      <span class="error-value"
                        >{{ $t('addExpectedVisitor.visitTimeCantBeforeNow') }}</span
                      >
                    </div>
                  </div>
                  <div
                    v-if="!visitTimeValidation && form.site"
                    class="hint-timezone"
                  >
                    <span>
                      <b>{{ $t("common.notes.note") }}:</b>
                      {{ $t("addExpectedVisitor.selectedVisitTimeSetTo") }} ({{
                        siteTimeZone
                      }}) {{ $t("addExpectedVisitor.timezone") }}.</span
                    >
                  </div>
                </div>
                <div v-if="addHost" class="seperator-line"></div>
                <div class="select-host" v-if="addHost">
                  <h6 class="hint-host-message">
                    {{ $t("addExpectedVisitor.selectTheHost") }}
                  </h6>
                  <div class="d-flex host-selection">
                    <VpMultiselect
                      zIndex="100"
                      :showPlaceholderIcon="true"
                      width="416"
                      :isLoading="hostLoading"
                      :showOptionsBorder="true"
                      :showNoResults="true"
                      v-model="form.host"
                      :label="hostSearchLabel"
                      :options="hostsOptions"
                      :allowEmpty="true"
                      :show-labels="false"
                      :searchable="true"
                      :title="
                        $t('addExpectedVisitor.searchByNamePhoneNumberEmail')
                      "
                      :disabled="!form.area || !haveUsersToSelectHost"
                      :noResultMessage="$t('common.noResults')"
                      @searchChange="searchByHostName"
                      @input="changeHostValue"
                    />
                  </div>
                  <div
                    v-if="!haveUsersToSelectHost && allowWithoutHost"
                    class="host-container"
                    style="margin-bottom: 30px"
                  >
                    <span class="no-users-host-message">
                      <b>{{ $t("common.notes.note") }}:</b>
                      {{
                        $t(
                          "addExpectedVisitor.noUsersAvailableSelectedAsHostCheckbox"
                        )
                      }}</span
                    >
                  </div>
                  <b-form-checkbox
                    v-if="allowWithoutHost"
                    v-model="form.allow_without_host"
                    @input="changeAllowWithoutHostValue"
                    class="check-host-button"
                    name="check-button"
                    >{{
                      $t("addExpectedVisitor.addTheVisitWithoutHost")
                    }}</b-form-checkbox
                  >
                </div>
              </div>
            </div>
          </b-form>
        </section>
      </template>

      <template v-slot:content-footer>
        <VpButton
          :disabled="disabledSubmitButton() || $v.customSections.$invalid"
          :text="$t('addExpectedVisitor.addVisit')"
          :height="'37px'"
          :width="'151px'"
          @click="opnenConfirmModal()"
          class="d-flex align-items-center add-visitor"
        />
      </template>
    </VpFormLayout>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "@/components/page-header";
import { numeric, required, email } from "vuelidate/lib/validators";
import VueCountryCode from "vue-country-code";
import moment from "moment";
import sectionService from "@/services/section";
import RenderFieldType from "@/components/users/section/RenderFieldType";
import { cloneDeep } from "lodash";
import { getCustomFieldsPayload } from "@/utils/mixins/customFieldValueParser";
import { requiredIf } from "vuelidate/lib/validators";
// import 'moment/locale/ar'

export default {
  title: "Add Visits",
  components: {
    PageHeader,
    VueCountryCode,
    RenderFieldType,
  },
  name: "addExpectedVisitors",
  // mixins:[getCustomFieldValueMixin],
  data() {
    return {
      currentLanguage : '',
      title: this.$t("addExpectedVisitor.addVisits"),
      timeValidation: false,
      dateValidation: false,
      dateValue: true,
      timeValue: false,
      addNewUser: false,
      addHost: false,
      allowWithoutHost: false,
      sitesLoading: true,
      areasLoading: false,
      userLoading: false,
      hostLoading: false,
      phoneLoading: false,
      emailLoading: false,
      userTypeLoading: false,
      emailValidation: false,
      phoneValidation: false,
      visitTimeValidation: false,
      visitDateValidation: false,
      confirmAddVisitor: false,
      isVisitError: false,
      sitesAndAreasByEntityId: [],
      userTypesByAreaId: [],
      usersOptions: [],
      hostsOptions: [],
      userTypesOptions: [],
      selected_user_type: [],
      userSearchValue: "",
      areasOptions: [],
      siteTimeZone: "",
      defaultTimeWithTimezone: "",
      currentDateWithTimezone: "",
      defaultCurrentDateAndTimeTimezone: null,
      visitErrorMessage: "",
      fullName: "",
      hostFullName: "",
      companyName: "",
      siteName: "",
      areaName: "",
      userTypeName: "",
      areaJourneyId: null,
      areaJourneyFlowId: null,
      userSearchLabel: "userName_with_userType",
      hostSearchLabel: "userName_with_userType",
      offset: null,
      daysDiff: null,
      timeInUTCFormat: null,
      dateInUTCFormat: null,
      visitDateWithSpecificFormat: "",
      visitTimeWithSpecificFormat: "",
      regEmail:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      regString: /[`!+\\=[\];':"\\|,./?~]/,
      newUser: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        country_code: "20",
        user_type: null,
        user_type_id: null,
      },
      form: {
        dateStringValue: "today",
        dateInputValue: "",
        timeInputValue: "",
        site: null,
        area: null,
        user: null,
        host: null,
        allow_without_host: false,
      },
      isSubmitted: false,
      userCountryCode: null,
      singleVisit: {
        disabled: false,
        showUserSection: true,
      },
      multipleVisits: {
        disabled: true,
        showUsersSection: false,
      },
      domainNameEnv: process.env.VUE_APP_DOMAIN,
      preRegistrationUrlEnv: process.env.VUE_APP_PRE_REGISTRATION_URL,
      preRegistrationUrl: "",
      showAreaPreRegistrationUrl: false,
      areaHasUserTypesToAddVisitor: false,
      haveUsersToSelectHost: true,
      customSections: [],
      customFieldValidation: false,
    };
  },
  validations: {
    newUser: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      email: {
        email,
      },
      phone: {
        numeric,
      },
    },
    customSections: {
      $each: {
        custom_fields: {
          $each: {
            value: {
              required: requiredIf(function (field) {
                return field.is_mandatory && !field.is_optional;
              }),
            },
          },
        },
      },
    },
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("visit", [
      "getSitesAndAreasByEntityId",
      "getUserTypesByAreaId",
      "getUsersBySearch",
      "getHostsBySearch",
      "getUsersByEmailOrPhone",
      "getExpectedVisitValidation",
      "getExpectedVisit",
      "getIfJourneyHasHost",
    ]),
    ...mapGetters("authfack", ["currentEntity", "userDetails", "getUserRole"]),
    // ...mapGetters("journey", ["getJourneyChecks"]),
  },
  methods: {
    ...mapActions("visit", [
      "fetchSitesAndAreasByEntityId",
      "usersBySearch",
      "hostsBySearch",
      "fetchUserTypesWithAreaId",
      "fetchUsersByEmailOrPhone",
      "chechIfUserHasExpextedVisit",
      "addExpextedVisit",
      "checkIfJourneyHasHost",
      "fetchAreaDataById",
    ]),
    ...mapActions("journey", ["fetchJourneyChecks"]),
    toggleSingleOrMultipleVisits(type) {
      if (type == "single") {
        this.multipleVisits.disabled = true;
        this.multipleVisits.showUsersSection = false;
        this.singleVisit.showUserSection = true;
      } else {
        this.singleVisit.disabled = true;
        this.singleVisit.showUserSection = false;
        this.multipleVisits.showUserSection = true;
      }
    },
    disableDateBeforeCurrent(date) {
      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      let currentMonth = currentDate.getMonth();
      let currentDay = currentDate.getDate();
      return date < new Date(currentYear, currentMonth, currentDay);
    },
    changeVisitDate(value) {
      this.confirmAddVisitor = false;
      this.visitDateValidation = false;
      this.isVisitError = false;
      this.visitErrorMessage = "";
      this.dateValue = true;
      this.visitTimeValidation = false;
      // this.form.dateStringValue = 'today';
      this.form.dateInputValue = "";
      let currentDateWithTimezone = "";
      this.form.timeInputValue = "";
      this.defaultTimeWithTimezone = null;
      let currentDateLocalString = new Date(
        new Date().toLocaleString("en-US", { timeZone: this.siteTimeZone })
      );
      this.defaultCurrentDateAndTimeTimezone = new Date(
        new Date(
          new Date().toLocaleString("en-US", { timeZone: this.siteTimeZone })
        ).getTime() +
          5 * 60000
      );
      // console.log('defaultCurrentDateAndTimeTimezone',this.defaultCurrentDateAndTimeTimezone);
      // console.log('currentDateLocalString',currentDateLocalString);
      if (value == "today") {
        currentDateWithTimezone = currentDateLocalString;
        this.defaultTimeWithTimezone = new Date(
          currentDateWithTimezone.getTime() + 5 * 60000
        );
      } else if (value == "tomorrow") {
        currentDateWithTimezone = new Date(
          currentDateLocalString.setDate(
            new Date(currentDateLocalString).getDate() + 1
          )
        );
        this.defaultTimeWithTimezone = new Date(
          currentDateWithTimezone.getTime() + 5 * 60000
        );
      } else if (value == "customDate") {
        this.dateValue = false;
        currentDateWithTimezone = currentDateLocalString;
      }
      this.form.dateStringValue = value;
      this.currentDateWithTimezone = currentDateWithTimezone;
      // console.log('currentDateWithTimezone', currentDateWithTimezone);
      // console.log('this.defaultTimeWithTimezone', this.defaultTimeWithTimezone);
      // console.log('this.currentDateWithTimezone', this.currentDateWithTimezone);
    },
    validateEmail(email) {
      let isEmailForm = false;
      if (this.regEmail.test(email)) {
        isEmailForm = true;
      }
      return isEmailForm;
    },
    searchByUserName(value) {
      value = value.trim();
      this.userLoading = true;
      this.confirmAddVisitor = false;
      this.emailValidation = false;
      this.phoneValidation = false;
      this.isVisitError = false;
      this.visitErrorMessage = "";
      this.userTypeName = "";
      this.newUser.user_type_id = null;
      this.addHost = false;
      this.allowWithoutHost = false;
      this.form.host = null;
      this.hostsOptions = [];
      this.form.allow_without_host = false;
      this.userSearchLabel = "userName_with_userType";
      this.customSections = [];
      const { usersBySearch, form } = this;
      if (value && value.length >= 3) {
        this.usersOptions = [];
        // console.log('value', value);
        let checkStringIsEmail = this.validateEmail(value);
        if (checkStringIsEmail) {
          this.userSearchLabel = "email";
        } else if (!isNaN(value)) {
          this.userSearchLabel = "phone";
        } else {
          this.userSearchLabel = "userName_with_userType";
        }
        // console.log('this.userSearchLabel',this.userSearchLabel);
        let formData = new FormData();
        formData.append("area_id", form.area);
        formData.append("search", value);
        setTimeout(() => {
          usersBySearch(formData).then((data) => {
            // console.log('users', data.data);
            this.addNewUser = false;
            this.newUser.first_name = "";
            this.newUser.last_name = "";
            this.newUser.user_type = null;
            this.newUser.email = "";
            this.newUser.phone = "";
            this.newUser.country_code = "20";
            this.form.user = null;
            if (data.data.length == 0) {
              this.userLoading = false;
              this.usersOptions = [];
              this.addNewUser = true;
              let checkStringIsEmail = this.validateEmail(value);

              if (checkStringIsEmail) {
                this.newUser.email = value;
              } else if (!isNaN(value)) {
                this.newUser.phone = value;
              } else {
                // value = value.replace(/[^a-zA-Z0-9 ]/g, '');
                if (!this.regString.test(value)) {
                  if (value.indexOf(" ") >= 0) {
                    this.newUser.first_name = value
                      .split(" ")[0]
                      ?.substring(0, 20);
                    this.newUser.last_name = value
                      .substring(value.split(" ")[0].length + 1, value.length)
                      .substring(0, 20);
                    // this.newUser.last_name = value.split(" ")[1]?.substring(0, 20);
                  } else {
                    this.newUser.first_name = value
                      .split(" ")[0]
                      ?.substring(0, 20);
                    this.newUser.last_name = value
                      .substring(value.split(" ")[0].length + 1, value.length)
                      .substring(0, 20);
                  }
                }
              }
              console.log("valueeeeeeee", value);

              this.userTypesOptions = this.userTypesByAreaId;
              console.log("this.userTypesOptions", this.userTypesOptions);
            } else {
              this.usersOptions = data.data;
              this.userLoading = false;
            }
          });
        }, 2000);
      } else if (!value && !this.form.user) {
        this.usersOptions = [];
        this.userLoading = false;
      } else {
        this.userLoading = false;
      }
    },
    checkUsersValidations() {
      if (this.newUser.email) {
        this.checkDuplicatedEmailOrPhone("email");
      }
    },
    searchByHostName(value, preSetHost = false) {
      // console.log('value', value);
      value = value.trim();
      this.hostSearchLabel = "userName_with_userType";
      this.hostLoading = true;
      const { hostsBySearch } = this;
      if (value && value.length >= 3) {
        this.hostsOptions = [];
        let checkStringIsEmail = this.validateEmail(value);
        if (checkStringIsEmail && !preSetHost) {
          this.hostSearchLabel = "email";
        } else if (!isNaN(value) && !preSetHost) {
          this.hostSearchLabel = "phone";
        } else {
          this.hostSearchLabel = "userName_with_userType";
        }
        // console.log('this.hostSearchLabel',this.hostSearchLabel);
        let formData = new FormData();
        formData.append("site_id", this.form.site ? this.form.site.id : "");
        formData.append("journey_flow_id", this.areaJourneyFlowId);
        formData.append(
          "user_id",
          this.form.user ? this.form.user.user_id : ""
        );
        formData.append(
          "user_type_id",
          this.form.user
            ? this.form.user.user_type_id
            : this.newUser.user_type_id
            ? this.newUser.user_type_id
            : ""
        );
        formData.append("search", value);
        setTimeout(() => {
          this.form.host = null;
          hostsBySearch(formData).then((data) => {
            // console.log('data', data.data);
            this.hostsOptions = data.data;
            this.hostLoading = false;
            if (
              data?.data &&
              this.addHost &&
              (this.getUserRole?.id == `${this.currentEntity?.id}-employee` ||
                this.getUserRole?.id ==
                  `${this.currentEntity?.id}-employee_with_reporting`) &&
              preSetHost === true
            ) {
              this.form.host = data?.data[0];
              preSetHost = false;
            }
          });
        }, 2000);
      } else if (!value && !this.form.host) {
        this.hostsOptions = [];
        this.hostLoading = false;
      } else {
        this.hostLoading = false;
      }
    },
    changeAllowWithoutHostValue(value) {
      this.hostFullName = "";
      this.allow_without_host = false;
      // this.hostsOptions = [];
      // console.log('value', value);
      if (value) {
        this.form.host = null;
        this.allow_without_host = value;
      }
    },
    changeSiteValue(site) {
      this.areasOptions = [];
      this.customSections = [];
      this.usersOptions = [];
      this.addNewUser = false;
      this.form.user = null;
      this.form.area = null;
      this.form.dateStringValue = "today";
      this.form.dateInputValue = "";
      this.form.timeInputValue = "";
      this.siteTimeZone = "";
      this.defaultTimeWithTimezone = "";
      this.defaultCurrentDateAndTimeTimezone = null;
      this.newUser.email = "";
      this.newUser.user_type = null;
      this.newUser.country_code = "20";
      this.newUser.phone = "";
      this.newUser.first_name = "";
      this.newUser.last_name = "";
      this.offset = null;
      this.areasOptions = site ? site.areas : [];
      this.siteTimeZone = site ? site.timezone : "";
      this.timeInUTCFormat = null;
      this.visitDateValidation = false;
      this.visitTimeValidation = false;
      this.confirmAddVisitor = false;
      this.isVisitError = false;
      this.visitErrorMessage = "";
      this.addHost = false;
      this.allowWithoutHost = false;
      this.form.host = "";
      this.form.allow_without_host = false;
      this.areaJourneyFlowId = null;
      this.preRegistrationUrl = "";
      this.showAreaPreRegistrationUrl = false;
      this.areaHasUserTypesToAddVisitor = false;
      this.haveUsersToSelectHost = true;
      // console.log('this.siteTimeZone', this.siteTimeZone);
      if (site && this.siteTimeZone) {
        this.defaultCurrentDateAndTimeTimezone = new Date(
        new Date(
          new Date().toLocaleString("en-US", { timeZone: this.siteTimeZone })
        ).getTime() +
          5 * 60000
      );
        let currentDateTimeWithUTC = new Date(
          new Date().toLocaleString("en-US", { timeZone: "UTC" })
        );
        let currentDateTimeWithTimezone = new Date(
          new Date().toLocaleString("en-US", { timeZone: this.siteTimeZone })
        );
        this.offset =
          currentDateTimeWithUTC.getTime() -
          currentDateTimeWithTimezone.getTime();
        // console.log('this.offset',this.offset);
      }
    },
    async changeAreaValue(id) {
      console.log("areaId", id, this.siteTimeZone);
      this.usersOptions = [];
      this.areasLoading = false;
      // this.userTypesByAreaId = [];
      this.customSections = [];
      this.addNewUser = false;
      this.form.user = null;
      this.areaJourneyId = null;
      this.visitDateValidation = false;
      this.visitTimeValidation = false;
      this.confirmAddVisitor = false;
      this.isVisitError = false;
      this.visitErrorMessage = "";
      this.form.dateStringValue = "today";
      this.currentDateWithTimezone = this.siteTimeZone
        ? new Date(
            new Date().toLocaleString("en-US", { timeZone: this.siteTimeZone })
          )
        : "";
      this.defaultTimeWithTimezone = this.siteTimeZone
        ? new Date(this.currentDateWithTimezone.getTime() + 5 * 60000)
        : "";
      this.form.dateInputValue = "";
      this.form.timeInputValue = "";
      this.areaName = "";
      this.addHost = false;
      this.allowWithoutHost = false;
      this.form.host = "";
      this.form.allow_without_host = false;
      this.areaJourneyFlowId = null;
      this.showAreaPreRegistrationUrl = false;
      this.preRegistrationUrl = "";
      this.haveUsersToSelectHost = true;
      this.areaHasUserTypesToAddVisitor = false;
      if (id) {
        this.areasLoading = true;
        this.fetchAreaDataById(id).then(async (data) => {
          // console.log('area', data);
          this.areaName = data.data.name;
          this.areaJourneyId = data.data.journey_id;
          this.preRegistrationUrl = `${this.domainNameEnv}/${this.preRegistrationUrlEnv}/${data.data.pre_registration_url}`;
          await this.fetchUserTypesWithAreaId(data.data.id).then(
            async (res) => {
              if (res.data && !res.data.length)
                this.areaHasUserTypesToAddVisitor = true;
              // console.log('res.data', res.data);
              else this.showAreaPreRegistrationUrl = true;
              this.userTypesByAreaId = await res.data;
              // console.log('this.userTypesByAreaId', this.userTypesByAreaId);
              this.areasLoading = false;
            }
          );
        });
      }
    },
    async changeUserValue(user) {
      console.log("user", user);
      // this.userLoading = false;
      this.confirmAddVisitor = false;
      this.isVisitError = false;
      this.visitErrorMessage = "";
      this.userTypeName = "";
      this.newUser.user_type_id = null;
      this.addHost = false;
      this.allowWithoutHost = false;
      this.form.host = null;
      this.hostsOptions = [];
      this.form.allow_without_host = false;
      this.areaJourneyFlowId = null;
      this.userLoading = true;
      this.haveUsersToSelectHost = true;
      if (user) {
        await this.checkIfJourneyHasHost({
          journeyId: this.areaJourneyId,
          userTypeId: user.user_type_id,
        }).then(async (data) => {
          // console.log('data',data.data);
          await this.ifJourneyHasHost(data.data);
          this.userLoading = false;
          if (data.data && !data.data.select_host_permitted)
            this.haveUsersToSelectHost = false;
        });
        await this.getCustomFieldsByUserTypeAndAreaId(
          user.user_type_id,
          this.form.area,
          user.id
        );
      } else {
        this.userLoading = false;
      }
    },
    changeHostValue() {
      this.form.allow_without_host = false;
    },
    async changeUserType(type) {
      // console.log('type',type);
      this.addHost = false;
      this.form.host = null;
      this.hostsOptions = [];
      this.allowWithoutHost = false;
      this.areaJourneyFlowId = null;
      this.userTypeLoading = true;
      this.userTypeName = "";
      this.newUser.user_type_id = null;
      this.haveUsersToSelectHost = true;
      if (type) {
        this.newUser.user_type_id = type;
        await this.checkIfJourneyHasHost({
          journeyId: this.areaJourneyId,
          userTypeId: type,
        }).then(async (data) => {
          // console.log('data',data.data);
          this.userTypeName = data.data.user_type_name;
          await this.ifJourneyHasHost(data.data);
          this.userTypeLoading = false;
          if (data.data && !data.data.select_host_permitted)
            this.haveUsersToSelectHost = false;
        });
        await this.getCustomFieldsByUserTypeAndAreaId(type, this.form.area, 0);
      } else {
        this.userTypeLoading = false;
      }
    },
    async getCustomFieldsByUserTypeAndAreaId(type, areaId, userId) {
      this.customSections = [];
      sectionService
        .getCustomFieldByAreaId({ userTypeId: type, areaId, userId })
        .then((res) => {
          console.log("res", res);
          res.data?.forEach((section) => {
            section.custom_fields?.forEach((field) => {
              let defaultValue = null;
              let isOptional = 0;

              if (field.type == "checkboxes") defaultValue = [];
              // else if(field.type == "toggleButton") defaultValue = null
              // else defaultValue = null

              if (field.is_mandatory && field.is_fillable_by_user)
                isOptional = 1;
              if (!field.is_mandatory && field.is_fillable_by_user)
                isOptional = 1;
              if (field.is_mandatory && !field.is_fillable_by_user)
                isOptional = 0;

              Object.assign(field, {
                value: defaultValue,
                is_optional: isOptional,
              });
            });
          });

          this.customSections = res.data;
          console.log("this.customSections", this.customSections);
        });
    },
    updateCustomField(field) {
      this.customSections?.forEach((section, sectionIndex) => {
        let updatedFieldIndex = section.custom_fields?.findIndex(
          (customField) => customField.id == field.id
        );
        if (updatedFieldIndex >= 0)
          this.customSections[sectionIndex].custom_fields[updatedFieldIndex] =
            field;
      });

      this.customSections = cloneDeep(this.customSections);
    },
    checkDuplicatedEmailOrPhone(type) {
      let value = "";
      this.emailLoading = false;
      this.phoneLoading = false;
      if (type == "email") {
        this.emailValidation = false;
        if (this.newUser.email) {
          this.emailLoading = true;
          value = this.newUser.email;
        }
      }
      if (type == "phone") {
        this.phoneValidation = false;
        if (this.newUser.phone) {
          this.phoneLoading = true;
          value = this.newUser.country_code + this.newUser.phone;
        }
      }

      // console.log('value',value);
      let formData = new FormData();
      formData.append("entity_id", this.currentEntity.id);
      formData.append("field", type);
      formData.append("value", value);
      if (type && value) {
        setTimeout(() => {
          this.fetchUsersByEmailOrPhone(formData).then((data) => {
            if (!data.data.available) {
              if (data.data.field == "email") {
                this.emailValidation = true;
              } else if (data.data.field == "phone") {
                this.phoneValidation = true;
              }
            }
            this.emailLoading = false;
            this.phoneLoading = false;
          });
        }, 2000);
      }
    },
    handleDateOrTimeFormat(value, type) {
      let stringValue = "";
      if (type == "date") {
        stringValue =  moment(value).locale("en-US").format("YYYY-MM-DD");
        // console.log('stringValueDDDDDD', stringValue);
      } else if (type == "time") {
        stringValue = moment(value).locale("en-US").format("HH:mm:ss");
        // console.log('stringValuetttttttttttttt', stringValue);
      }
      return stringValue;
    },
    onSelectUserCountryCode({ dialCode }) {
      this.newUser.country_code = dialCode;
    },
    changeVisitTimeValidation() {
      this.timeInUTCFormat = null;
      this.visitTimeValidation = false;
      this.confirmAddVisitor = false;
      this.isVisitError = false;
      this.visitErrorMessage = "";
      // console.log('this.form.timeInputValue',this.form.timeInputValue);
      // console.log('this.defaultCurrentDateAndTimeTimezone',this.defaultCurrentDateAndTimeTimezone);
      if (
        this.form.timeInputValue &&
        new Date(this.defaultCurrentDateAndTimeTimezone) >
          this.form.timeInputValue
      ) {
        this.visitTimeValidation = true;
      }
      let currentDateTimeWithUTC = new Date(
        new Date().toLocaleString("en-US", { timeZone: "UTC" })
      );
      // const selectedDateStamp = Date.parse(moment(this.form.timeInputValue).format("YYYY-MM-DD"));
      const dateDiff =
        Date.parse(
          moment(new Date(this.form.timeInputValue)).format("YYYY-MM-DD")
        ) - Date.parse(moment(currentDateTimeWithUTC).format("YYYY-MM-DD"));
      this.daysDiff = dateDiff / (60 * 60 * 24 * 1000);
      // console.log('this.daysDiff', this.daysDiff);
      // if (this.daysDiff != 0) {
      // this.timeInUTCFormat = new Date(selectedDateStamp - this.daysDiff * 24 * 60 * 60 * 1000);
      this.timeInUTCFormat = new Date(
        new Date(this.form.timeInputValue).getTime() + this.offset
      );
      this.dateInUTCFormat = new Date(
        new Date(this.timeInUTCFormat).getTime() + this.offset
      );
      // console.log('this.timeInUTCFormat', this.timeInUTCFormat);
      // }
    },
    changeVisitDateValidation() {
      this.confirmAddVisitor = false;
      this.visitDateValidation = false;
      this.visitTimeValidation = false;
      this.isVisitError = false;
      this.visitErrorMessage = "";
      this.form.timeInputValue = null;
      this.timeInUTCFormat = null;
      let defaultTimeWithTimezone = new Date(
        new Date(this.currentDateWithTimezone).getTime() + 5 * 60000
      );

      // console.log('defaultTimeWithTimezone',defaultTimeWithTimezone);

      this.defaultTimeWithTimezone = new Date(
        moment(this.form.dateInputValue).set({
          hour: defaultTimeWithTimezone.getHours(),
          minute: defaultTimeWithTimezone.getMinutes(),
          second: defaultTimeWithTimezone.getSeconds(),
        })
      );

      // console.log('this.defaultTimeWithTimezone',new Date(this.defaultTimeWithTimezone));
    },
    opnenConfirmModal() {
      this.siteName = "";
      this.fullName = "";
      this.visitDateWithSpecificFormat = "";
      this.companyName = this.currentEntity.name;
      this.siteName = this.form.site.name;
      if (this.form.dateInputValue) {
        this.visitDateWithSpecificFormat = moment(
          this.form.dateInputValue
        ).locale(this.currentLanguage).format("DD MMMM YYYY");
      } else {
        this.visitDateWithSpecificFormat = moment(
          this.currentDateWithTimezone
        ).locale(this.currentLanguage).format("DD MMMM YYYY");
      }
      this.visitTimeWithSpecificFormat = moment(
        this.form.timeInputValue
      ).locale(this.currentLanguage).format("hh:mm A");
      if (this.form.user) {
        this.fullName = this.form.user.fullName;
        this.userTypeName = this.form.user.name;
      } else {
        this.fullName = this.newUser.first_name + " " + this.newUser.last_name;
        // this.userTypeName = this.newUser.user_type;
      }

      if (this.form.host) {
        this.hostFullName = ` ${this.$t('addExpectedVisitor.andTheHostWillBe')} ${this.form.host.userName} (${this.form.host.name})`;
      }
      this.$bvModal.show("confirmModal");
    },
    checkDates(value, type) {
      let inValidVisit = false;
      let current = new Date().toLocaleString("en-US", {
        timeZone: this.siteTimeZone,
      });
      if (type == "date") {
        value = moment(value).format("YYYY-MM-DD");
        current = moment(current).format("YYYY-MM-DD");
        // console.log('datedatedatedatedate',value);
        // console.log('currentDatecurrentDate',current);
      } else if (type == "time") {
        current = new Date(new Date(current).getTime());
        // console.log('currentTimecurrentTimevalue',value );
        // console.log('currentTimecurrentTime',current);
      }

      if (current > value) {
        if (type == "date") {
          this.visitDateValidation = true;
        } else if (type == "time") {
          this.visitTimeValidation = true;
        }
        inValidVisit = true;
      }
      return inValidVisit;
    },
    async ifJourneyHasHost(data) {
      // console.log('data', data);
      this.addHost = data.host_enable;
      this.allowWithoutHost = data.allow_not_select_host;
      this.areaJourneyFlowId = data.journey_flow_id;

      if (
        this.addHost &&
        (this.getUserRole?.id == `${this.currentEntity?.id}-employee` ||
          this.getUserRole?.id ==
            `${this.currentEntity?.id}-employee_with_reporting`)
      ) {
        const userInfo = this.userDetails.email || this.userDetails.phone;
        this.searchByHostName(userInfo, true);
      }
    },
    disabledSubmitButton() {
      // console.log('this.customSections', this.customSections);
      let status = true;
      if (
        this.form.site &&
        this.form.area &&
        this.form.dateStringValue &&
        this.form.timeInputValue &&
        !this.visitTimeValidation &&
        !this.visitDateValidation &&
        (this.form.user ||
          (this.newUser.first_name &&
            this.newUser.last_name &&
            this.newUser.user_type)) &&
        !this.emailValidation &&
        !this.phoneValidation &&
        !this.isVisitError
      ) {
        status = false;
      }
      if (
        this.form.dateStringValue == "customDate" &&
        !this.form.dateInputValue
      ) {
        status = true;
      }
      if (
        this.addHost &&
        !this.form.host &&
        !this.form.allow_without_host &&
        this.haveUsersToSelectHost
      ) {
        status = true;
      }
      //#TODO => Remove once worked with vuelidate
      // if(this.customSections.length){
      //     this.customSections?.forEach(section=>{
      //         section.custom_fields?.forEach(field=>{
      //             if(field.is_mandatory) console.log(field.name)
      //             if(field.is_mandatory && !field.is_fillable_by_user && (!field.value || !field.value.length)){
      //                 status = true;
      //             }
      //         })
      //     })
      // }
      return status;
    },
    async onSubmit() {
      console.log("this.customSections", this.customSections);
      this.confirmAddVisitor = true;
      const { form, newUser, chechIfUserHasExpextedVisit, addExpextedVisit } =
        this;
      let dateValueWithFormat = this.dateInUTCFormat;
      let timeValueWithFormat = this.timeInUTCFormat
        ? this.timeInUTCFormat
        : this.form.timeInputValue;

      let inValidVisitDate = this.checkDates(
        this.currentDateWithTimezone,
        "date"
      );
      let inValidVisitTime = this.checkDates(this.form.timeInputValue, "time");

      if (inValidVisitDate || inValidVisitTime) {
        this.$bvModal.hide("confirmModal");
        return;
      }

      let dateInputWithUTCFormat = this.handleDateOrTimeFormat(
        dateValueWithFormat,
        "date"
      );
      let timeInputWithUTCFormat = this.handleDateOrTimeFormat(
        timeValueWithFormat,
        "time"
      );

      console.log("dateInputWithUTC", dateValueWithFormat);
      console.log("timeValueWithFormat", timeValueWithFormat);
      console.log("dateInputWithUTCFormat", dateInputWithUTCFormat);
      console.log("timeInputWithUTCFormat", timeInputWithUTCFormat);
      console.log("form", form);
      console.log("newUser", newUser);

      let formData = new FormData();
      formData.append("entity_id", this.currentEntity.id);
      formData.append("user_id", form.user ? form.user.user_id : "");
      formData.append("area_id", form.area);
      formData.append("visit_date", dateInputWithUTCFormat);
      formData.append("visit_time", timeInputWithUTCFormat);
      formData.append("first_name", this.newUser.first_name);
      formData.append("last_name", this.newUser.last_name);

      let customFields = getCustomFieldsPayload(this.customSections);

      console.log("customFields", customFields);
      formData.append(
        "custom_fields",
        customFields.length ? JSON.stringify(customFields) : ""
      );

      chechIfUserHasExpextedVisit(formData)
        .then(() => {
          // console.log("data", data);
          formData.append("host", this.form.host ? this.form.host.user_id : "");
          formData.append(
            "allow_not_select_host",
            this.form.allow_without_host ? 1 : 0
          );
          if (!this.form.user) {
            formData.append(
              "user_type_id",
              this.newUser.user_type ? this.newUser.user_type : ""
            );
            formData.append("email", this.newUser.email);
            formData.append(
              "phone",
              this.newUser.phone
                ? `${this.newUser.country_code}${this.newUser.phone}`
                : ""
            );
          }
          addExpextedVisit(formData)
            .then(() => {
              // document.getElementById("preloader").style.display = "block";
              // document.getElementById("status").style.display = "block";
              this.changeSiteValue(this.form.site);
              this.$bvModal.hide('confirmModal');
            })
            .catch((e) => {
              console.log("e", e);
              this.$bvModal.hide("confirmModal");
            });
        })
        .catch((e) => {
          console.log("e", e);
          this.$bvModal.hide("confirmModal");
        });
    },
  },
  watch: {
    // getUserTypesByAreaId(){
    //     console.log('userTypes');
    // },
    // getUsersBySearch(users){
    //     // this.usersOptions = users;
    //     this.usersOptions = [];
    //     this.form.user = '';
    //     this.emailValidation = false;
    //     this.phoneValidation = false;
    //     this.isVisitError = false;
    //     this.visitErrorMessage = '';
    //     this.newUser.first_name = '';
    //     this.newUser.last_name = '';
    //     this.newUser.user_type = '';
    //     this.newUser.email = '';
    //     this.newUser.phone = '';
    //     this.newUser.country_code = '20';
    //     this.addNewUser = false;
    //     this.addHost = false;
    //     this.allowWithoutHost = false;
    //     this.form.host = '';
    //     this.form.allow_without_host = false;
    //     if(users.length == 0){
    //         this.form.user = null;
    //         this.addNewUser = true;
    //         let checkStringIsEmail = this.validateEmail(this.userSearchValue);
    //         if(checkStringIsEmail){
    //             this.newUser.email = this.userSearchValue;
    //         }else if(!isNaN(this.userSearchValue)){
    //             this.newUser.phone = this.userSearchValue;
    //         }else{
    //             if(!this.regString.test(this.userSearchValue)){
    //                 if(this.userSearchValue.indexOf(' ') >= 0){
    //                     this.newUser.first_name = this.userSearchValue.split(" ")[0];
    //                     this.newUser.last_name = this.userSearchValue.split(" ")[1];
    //                 }else{
    //                     this.newUser.first_name = this.userSearchValue;
    //                 }
    //             }
    //         }
    //     }else{
    //         // console.log('users', users);
    //         this.usersOptions = users;
    //     }
    // },
    // getHostsBySearch(hosts){
    //     // console.log('hosts',hosts);
    //     this.hostsOptions = hosts;
    // },
    // getUsersByEmailOrPhone(data){
    //     console.log('data', data);
    //     if(!data.available){
    //         if(data.field == 'email'){
    //             this.emailValidation  = true;
    //         }else if(data.field == 'phone'){
    //             this.phoneValidation  = true;
    //         }
    //     }
    // },
    getExpectedVisitValidation(data) {
      // console.log('erro data',data);
      if (data.status == "error") {
        this.isVisitError = true;
        this.visitErrorMessage = data.data.message;
      }
    },
    getExpectedVisit(data) {
      if (data.errors) {
        if (data.errors.visit_time) {
          this.visitTimeValidation = true;
        }
        if (data.errors.visit_date) {
          this.visitDateValidation = true;
        }
      }
    },
  },
  beforeMount() { 
    document.title = this.$t('addExpectedVisitor.addVisits');
    this.currentLanguage = this.getLanguage;
    this.fetchSitesAndAreasByEntityId().then((data) => {
      this.sitesAndAreasByEntityId = data.data;
      this.sitesLoading = false;
    });
  },
};
</script>   

<style lang="scss">
// .light{
//     color:red;
//     background: green;
// }
.user-type-select {
  .vue-treeselect__control
    .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
    font-weight: 700 !important;
  }
}
div#confirmModal {
  div#confirmModal___BV_modal_content_ {
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgb(0 0 0 / 5%);
    border-radius: 26px;
    // width:580px;
    top: 50%;
    div#confirmModal___BV_modal_body_ {
      padding: 0px !important;

      p.header-title {
        font-weight: 700;
        font-size: 17px;
        line-height: 20px;
        margin: 41px 46px 38px 46px;
        color: #000000;
      }
      .hint-modal {
        font-weight: 400;
        font-size: 20px;
        line-height: 24px;
        margin: 0 55px 43px 55px;
        text-align: center;
        color: #787878;
      }
      .h-line {
        opacity: 0.15;
        background: #707070;
        // width:488px;
        margin: 0px 45px 20px 45px;
      }
      .action-btns {
        margin-bottom: 30px;
        .start-btn {
          background: #103f5e;
          border-radius: 16.6275px;
          width: 111px;
          height: 33px;
          justify-content: center;
          color: #ffffff;

          font-weight: 400;
          font-size: 16px;
          align-items: center;
          display: flex;
          line-height: 19px;
          text-align: center;
          margin-inline-end: 31px;
        }
        .cancel-btn {
          align-items: center;
          display: flex;
          border: 1.5px solid #f46a6a;
          border-radius: 16.6275px;
          justify-content: center;
          color: #f46a6a;

          font-weight: 400;
          font-size: 16px;
          line-height: 19px;
          text-align: center;
        }
      }
    }
  }
}

// .expected-visitors-container{
//     .multiselect__tags {
//         background: #f2f2f2 !important;
//     }
// }

.add-margin-top-bottom {
  margin-top: 32px;
  margin-bottom: 32px;
}
.areas-options {
  .vue-treeselect__menu-container {
    z-index: 999999;
  }
  .vue-treeselect--single .vue-treeselect__input {
    padding-inline-start: 37px;
    margin-top: 5px;
  }
  .vue-treeselect__x-container {
    display: none;
  }
  .vue-treeselect__control {
    width: 416px;
    height: 55px;
    background: #f2f2f2 !important;
    margin-bottom: 17px;
    // padding-inline-start: 4px;
    border-radius: 4px;
    border: none;
    position: relative;

    .vue-treeselect__multi-value {
      min-height: 55px !important;
      display: flex;
      flex-wrap: wrap;
      .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
        position: absolute;
        top: 20px;
        inset-inline-start: 10px;

        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        // margin-inline-start: 15px;
        /* identical to box height, or 106% */

        letter-spacing: 0.25px;

        color: #787878;
      }
    }
  }
  .vue-treeselect svg {
    fill: #787878;
  }
  .vue-treeselect__multi-value-item {
    cursor: pointer;
    display: inline-table;
    background: #103f5e;
    padding: 0px !important;
    border: none;
    border-radius: 6px;
    height: 39px;
    // min-width: 92px;
    color: #ffff;
    font-size: 12px;
    vertical-align: top;

    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
  }
  .vue-treeselect__value-remove {
    border: none !important;
    width: 33px;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
  }

  .vue-treeselect__menu::-webkit-scrollbar {
    width: 9px;
    height: 30px !important;
  }
  .vue-treeselect__menu::-webkit-scrollbar-track {
    background: #c7c7c7;
    padding-top: 30px !important;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
    margin-top: 5px !important;
    margin-bottom: 13px !important;
  }
  .vue-treeselect__menu::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
  }
  .vue-treeselect__list {
    width: 406px;
  }
  .vue-treeselect__option {
    border-top: 1px solid #ebebeb;
    padding-inline-end: 10px;
  }
  .vue-treeselect__label {
    font-size: 16px;
    font-weight: 400;
    font-size: 16px;
    color: #787878;
    padding-inline-start: 12px;
    padding-top: 10px;
    padding-bottom: 10px;
    white-space: normal;
  }
  .vue-treeselect__list-item {
    width: 98% !important;
  }

  .vue-treeselect__list:first-of-type
    > .vue-treeselect__list-item:first-of-type
    > .vue-treeselect__option:first-of-type {
    border-top: none;
  }
  .vue-treeselect__input-container {
    font-size: 16px;
    margin-top: 15px;
    padding-inline-start: 15px;
  }
  .vue-treeselect__checkbox {
    background-color: #ffffff !important;
    padding: 5px !important;
    border: 3px solid #787878 !important;
    border-radius: 3px !important;
    width: 17px !important;
    height: 17px !important;
  }
  .vue-treeselect__checkbox--checked {
    background-color: #787878 !important;
    border: solid #787878 3px !important;
  }
  .vue-treeselect__check-mark,
  .vue-treeselect__minus-mark {
    background-color: #787878 !important;
    border: none !important;
  }
  .vue-treeselect--disabled .vue-treeselect__placeholder {
    opacity: 0.3;
    margin-inline-start: 20px;
  }

  .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    padding-top: 20px;
    padding-inline-start: 15px;
    letter-spacing: 0.25px;
    color: #787878;
    margin-inline-start: 36px;
  }
  .vue-treeselect__single-value {
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    padding-top: 30px;
    padding-inline-start: 15px;
    color: #4a4a4a !important;
    margin-inline-start: 30px;
  }
  .highZIndex {
    z-index: 99;
  }
}
</style>

<style lang="scss" scoped>
::v-deep {
  .mx-datepicker-main.mx-datepicker-popup {
    z-index: 9999999999999;
  }
  .area-select .multiselect__content-wrapper {
    position: absolute;
  }
  .expected-visitors-section {
    .check-host-button.custom-control.custom-checkbox {
      .custom-checkbox .custom-control-label::before {
        border: 3px solid #103f5e !important;
      }
    }

    .multiselect__content-wrapper {
      z-index: 100;
    }
    height: auto !important;
    background-color: white;
    border-radius: 8px;
    padding: 32px;
    .is-invalid {
      border: 1.5px solid #f46a6a !important;
      border-radius: 4px;
    }
    .is-invalidSecond {
      border: 2px solid #f46a6a !important;
    }

    input#email,
    input#phone {
      height: 35px !important;
    }
    input#email,
    input#companyName,
    input#vehicleRegistration,
    input#phone {
      .m-d-gruop > label {
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 17px !important;
        letter-spacing: 0.25px !important;
        color: rgba(96, 96, 96, 0.87) !important;
        opacity: 0.8 !important;
      }
      .m-d-gruop > .form-control:valid ~ label {
        font-weight: 700 !important;
        font-size: 12px !important;
        line-height: 17px !important;
        letter-spacing: 0.25px !important;
        color: #103f5e !important;
        bottom: 40px !important; //editable
      }
      .md-field.md-theme-default.md-has-value.md-has-placeholder.md-invalid {
        height: 56px !important;
      }
      .m-d-gruop > .form-control:focus ~ label {
        font-weight: 700 !important;
        font-size: 12px !important;
        line-height: 17px !important;
        letter-spacing: 0.25px !important;
        color: #103f5e !important;
        bottom: 40px !important; //editable
      }
    }
    .expected-visitors-container {
      //     label.custom-control-label {
      //     position: relative;
      //     padding-inline-start:9px;
      // }
      // .custom-radio .custom-control-label::before  {
      //     color: #fff;
      //     width: 20px;
      //     height: 20px;
      //     border-color: #C7C7C7!important;
      //     background: #C7C7C7!important;
      //     opacity: 0.3;
      // }
      // .first-radio{
      //     .custom-control-input:checked ~ .custom-control-label::before {
      //         color: #fff;
      //         width: 20px;
      //         height: 20px;
      //         border-color: #C7C7C7!important;
      //         background: #C7C7C7!important;
      //         opacity: 0.3;
      //     }
      //     .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
      //         background-image: none;
      //         background: #34C38F!important;
      //         width: 10px;
      //         height: 10px;
      //         border-radius: 50%;
      //         position: absolute;
      //         top: 7px;
      //         inset-inline-start: -19px;
      //     }
      // }
      .visit-type-action {
        // margin-inline-start: -16px !important;
        .single-visit,
        .multiple-visit {
          width: 125px;
          height: 27px;
          display: flex;
          align-items: center;
          justify-content: center;

          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          text-align: center;
          margin-inline-end: 27px;
        }
      }
      .visit-details {
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        padding-bottom: 31px;
        color: #787878;
      }
      .visit-date-custom {
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        padding-bottom: 24px;
        color: #c7c7c7;
      }
      .visit-date {
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        padding-bottom: 31px;
        color: #787878;
      }

      .visit-time {
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        padding-bottom: 31px;
        color: #787878;
        margin-top: 32px;
      }

      .custom-line {
        width: 1px;
        height: 27px;
        opacity: 0.08;
        background: #000000;
        opacity: 0.08;
        // margin-inline-end: 32px;
        // margin-inline-start: 32px;
      }

      .vue-treeselect__single-value {
        // margin-inline-start: 50px!important;
        color: #4a4a4a !important;
      }

      .ml-50 {
        margin-inline-start: 50px;
      }

      .ml-32 {
        margin-inline-start: 32px;
      }

      // .multiselect{
      //     width:422px!important;
      //     margin-bottom: 17px;
      //     border-radius: 4px!important;
      //     .multiselect__select{
      //         top:7px!important;
      //     }
      //     .multiselect__tags{
      //         height:55px!important;
      //         background: #f2f2f2!important;
      //         border-radius: 4px!important;
      //         border: none!important;
      //         display: flex;
      //         align-items: center;
      //         .multiselect__single{
      //             background: #f2f2f2!important;
      //
      //
      //             font-weight: 400;
      //             font-size: 16px;
      //             line-height: 17px;
      //             width: 300px!important;
      //             /* identical to box height, or 106% */
      //             letter-spacing: 0.25px;
      //             /* Input text */
      //             color: rgba(0, 0, 0, 0.87);
      //             opacity: 0.8;
      //         }
      //         .multiselect__placeholder {
      //
      //
      //             font-weight: 400;
      //             font-size: 16px;
      //             line-height: 17px;
      //             margin-inline-start:57px;
      //             letter-spacing: 0.25px;
      //             color: #606060 !important;
      //         }
      //     }
      // }
      //////////////////////////////
      // input#user-type{
      //  .multiselect {
      // z-index: auto!important;
      // }
      // .multiselect.multiselect--above {
      //     z-index: auto!important;
      // }
      // }
      /////////////////////////////

      input#siteName {
        height: 55px;
        background: #f2f2f2;
        border-radius: 4px !important;
        border: none;
        outline: none;

        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        position: relative;
        letter-spacing: 0.25px;
        color: rgba(0, 0, 0, 0.87);
        opacity: 0.8;
        padding-inline-start: 20px;
        transition: 0.6s !important;
        &::placeholder {
          font-weight: 400;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;

          color: rgba(96, 96, 96, 0.87);
          // opacity: 0!important;
          // opacity: 0.8
        }
        &:focus::placeholder {
          font-weight: 700 !important;
          font-size: 12px !important;
          line-height: 17px !important;
          letter-spacing: 0.25px;
          z-index: 99999;
          color: #103f5e !important;
          transform: translate(0px, -19px);
          // opacity: 0.8;
        }
      }

      input#select-site,
      input#select-area,
      input#search-by,
      input#host-search-by,
      input#user-type {
        background: #f2f2f2 !important;
        //   border-radius: 4px!important;

        font-weight: 400;
        font-size: 16px;
        line-height: 17px;
        padding-inline-start: 57px !important;
        /* identical to box height, or 106% */

        letter-spacing: 0.25px;

        color: rgba(0, 0, 0, 0.87);

        opacity: 0.8;
        &::placeholder {
          font-weight: 400;
          font-size: 16px;
          line-height: 17px;
          // padding-inline-start:57px!important;
          /* identical to box height, or 106% */

          letter-spacing: 0.25px;

          color: rgba(0, 0, 0, 0.87);

          opacity: 0.8;
        }
      }

      // span.multiselect__single{
      //
      //
      // font-weight: 900!important;
      // font-size: 16px;
      // line-height: 17px;
      // margin-inline-start:57px!important;
      // /* identical to box height, or 106% */

      // letter-spacing: 0.25px;

      // color: rgba(0, 0, 0, 0.87);

      // opacity: 0.8;
      //   }
      i.fa.fa-search.session-icon {
        margin-inline-end: 22px;
        margin-inline-start: 20px;
      }

      .top-page-btn {
        height: 27px;
        font-size: 16px;
      }

      .select-user {
        margin-top: 0px;
        .spinner-border {
          margin-inline-start: 10px;
          margin-top: 10px;
        }
      }

      .new-user {
        margin-top: 17px !important;
      }
    }
  }
  .pre-reg-datepicker {
    input.mx-input::placeholder {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      letter-spacing: 0.25px;
      margin-inline-start: 20px;
      padding-inline-start: 10px;
      color: #787878;
    }
    .mx-input:disabled {
      &::placeholder {
        color: #787878;

        // opacity: 0.2;
      }
    }
  }

  .date-radio {
    label.custom-control-label {
      position: relative;
      padding-inline-start: 16px;

      font-size: 16px;
      font-weight: 600;
      line-height: 17px;
      letter-spacing: 0.25px;
      text-align: start;

      color: #787878;

      // opacity: 0.8;
    }
    .custom-control-input:checked ~ .custom-control-label {
      font-size: 16px;
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.25px;
      text-align: start;

      color: #103f5e;

      // opacity: 0.8;
    }

    .custom-control-input:checked ~ .custom-control-label::before {
      color: #ffff;
      width: 20px;
      height: 20px;
      border: 2.5px solid #103f5e !important;
      background-color: #ffff !important;
      // opacity: 0.3;
    }
    .custom-control-input ~ .custom-control-label::before {
      color: #ffff;
      width: 20px;
      height: 20px;
      border: 2.5px solid #103f5e !important;
      background-color: #ffff !important;
      // opacity: 0.3;
    }
    .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
      background-image: none;
      background: #103f5e !important;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      position: absolute;
      top: 7px;
      inset-inline-start: -19px;
    }

    // label.custom-control-label {
    //     position: relative;
    //     padding-inline-start:9px;
    //     font-size: 16px;
    // }
    .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      width: 20px;
      height: 20px;
      border: 2.5px solid #103f5e !important;
      background-color: #ffff !important;
      // opacity: 0.3;
    }

    .custom-control-label span {
      top: 2px !important;
    }
  }

  .date-radio-error {
    label.custom-control-label {
      position: relative;
      padding-inline-start: 16px;

      font-weight: 400;
      font-size: 16px;
      line-height: 17px;
      /* identical to box height, or 106% */

      letter-spacing: 0.25px;

      /* #606060 */

      color: #c7c7c7;

      opacity: 0.8;
    }
    .custom-control-input:checked ~ .custom-control-label {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      /* identical to box height, or 106% */

      letter-spacing: 0.25px;

      /* Main Button */

      color: #f46a6a;

      opacity: 0.8;
    }

    .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      width: 20px;
      height: 20px;
      border: 2.5px solid #103f5e !important;
      background-color: #ffff !important;
      // opacity: 0.3;
    }
    .custom-control-input ~ .custom-control-label::before {
      color: #fff;
      width: 20px;
      height: 20px;
      border-color: #103f5e !important;
      background-color: #ffff !important;
      //opacity: 0.3;
    }
    .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
      background: #f46a6a !important;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      position: absolute;
      top: 7px;
      inset-inline-start: -19px;
    }

    // label.custom-control-label {
    //     position: relative;
    //     padding-inline-start:9px;
    //     font-size: 16px;
    // }
    .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      width: 20px;
      height: 20px;
      border: 2.5px solid #f46a6a !important;
      background-color: #ffff !important;
      // opacity: 0.3;
    }
    .custom-control-label span {
      top: 2px !important;
    }
  }

  .select-host {
    .spinner-border {
      margin-inline-start: 10px;
      margin-top: 10px;
    }
  }
}
.custom-checkbox .custom-control-label::before {
  border: 3px solid red !important;
}
.multiselect__select:before {
  color: #636161 !important;
  margin-top: 4px;
  border-color: #636161 transparent transparent !important;
}
.seperator-line {
  height: 1px;
  // width:1140px!important;
  margin: 32px 0px 32px 0px;
  background: #000000;
  opacity: 0.08;
}

.seperator-line2 {
  height: 8px;
  // width:1140px!important;
  margin: 31px 0px 27px 0px;
  background: #000000;
  opacity: 0.08;
}

.mx-datepicker {
  width: 200px !important;

  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 17px !important;
  /* identical to box height, or 106% */

  letter-spacing: 0.25px;

  color: rgba(0, 0, 0, 0.87);

  opacity: 0.8;
  ::placeholder {
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;

    letter-spacing: 0.25px;

    color: #787878 !important;
  }
  margin-top: -13px;
}
.pre-reg-datepicker.mx-datepicker.disabled {
  opacity: 0.5;
}
.new-user {
  font-size: 16px;
  .first-last-name-wrapper {
    display: flex;
    flex-direction: column;
    .required-star {
      position: relative;
      .required {
        color: #e51414;
        position: absolute;
        inset-inline-end: 10px;
        top: 18px;
        z-index: 59;
        font-size: 1.2rem;
      }
    }
  }
  .m-d-gruop {
    width: 416px !important;
  }

  .phone-input {
    width: 290x !important;
  }
  .current-phone {
    .phone-group {
      display: flex;
    }
    .country-code-input {
      margin-inline-end: 14px;
      // margin-top: 4px;
    }
  }
  .current-phone .phone-group .country-code-input {
    width: 110px;
    height: 55px;
    background-color: #f2f2f2;
    border-radius: 4px !important;
    border: none;
    z-index: 1 !important;
    .is-invalid {
      border: 1.5px solid #f46a6a !important;
      border-radius: 4px;
    }
  }
  .passport-email-phone {
    margin-bottom: 17px;
  }
  .register-account-check-wrapper {
    display: flex;
    padding-top: 0;
    padding-inline-end: 28px;
    padding-bottom: 0;
    padding-inline-start: 18px;
    margin-bottom: 131px;
    .custom-checkbox-dark {
      margin-inline-end: 16px;
    }
    .text {
      margin: 0;
      text-align: start;
      color: #666666;
      font-size: 16px;
    }
  }
}

.submit-action {
  margin-top: 40px;
  // margin-inline-start: -17px;
  .add-visitor {
    border-radius: 18.5px;
    width: 151px;
    height: 37px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 17px;
    /* identical to box height, or 106% */

    text-align: center;
    letter-spacing: 0.25px;

    color: #ffffff;
  }
}

.mr-17 {
  margin-inline-end: 17px !important;
}
.mr-32 {
  margin-inline-end: 32px !important;
}
.mr-14 {
  margin-inline-end: 14px !important;
}
.sites-areas-selection {
  margin-bottom: 31px;
  // margin-inline-start: 24px;
  .pre-registration-url-hint {
    margin-top: 8px;
    margin-inline-start: 20px;
    width: 376px;
    color: #939393;
    font-size: 14px;

    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0.25px;
    justify-content: center;
  }
  .router-color a {
    color: #103f5e !important;
    font-weight: 700 !important;
  }
}
.search-element {
  margin-inline-end: -40px;
  z-index: 999;
  margin-top: 15px;
}
.err-wrapper-two {
  // margin-top: -30px;
  // margin-inline-end: 170px;
  // margin-inline-start: 670px;
  justify-content: left;
  display: revert;
}
span.error-value-two {
  font-weight: 600 !important;
  font-size: 14px !important;
  line-height: 19px !important;
  /* identical to box height, or 136% */
  padding-inline-start: 0px !important;
  letter-spacing: 0.25px !important;

  /* #F46A6A */

  color: #f46a6a !important;
}
// .err-wrapper{
//     margin-top:36px !important;
//     margin-bottom:38px !important;
// }
span.error-value {
  font-weight: 600 !important;
  font-size: 14px !important;
  line-height: 19px !important;
  /* identical to box height, or 136% */
  padding-inline-start: 0px !important;
  letter-spacing: 0.25px !important;

  /* #F46A6A */

  color: #f46a6a !important;
}

// .visit-error-message{
//     width: 100%;
//     height: 38px;
// }

.visit-time-error {
  margin-top: 0px !important;
  margin-inline-start: -10px !important;
}

.hint-timezone {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  // margin-bottom: 48px !important;
  color: #939393;
  margin-top: 8px;
  opacity: 0.8;
  margin-inline-start: 20px;
  width: 167px;
}

.phone-email-loader {
  float: inline-end;
  margin-top: -32px;
  margin-inline-end: 7px;
}

.userType-loader {
  float: inline-end;
  margin-top: -60px;
  margin-inline-end: 30px;
}

.hint-host-message {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #787878;
  margin-top: 48px;
  margin-bottom: 31px;
}

.check-host-button {
  margin-top: 14px;

  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #666666;
  mix-blend-mode: normal;
}

.host-selection {
  margin-bottom: 0px !important;
}

.no-users-host-message {
  color: #939393;
  margin-top: 10px;
  margin-inline-start: 20px;

  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0.25px;
  text-align: start;

  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.25px;
  text-align: start;
}

.pointer {
  cursor: pointer !important;
}

.radios-con {
  .form-group {
    margin-bottom: 0rem !important;
  }
  .col-form-label {
    color: #787878 !important;
    font-weight: 600;
    font-size: 16px;
    line-height: 17px;

    margin-bottom: 32px !important;
    padding-bottom: 0px !important;
  }
  .custom-control-inline:not(:last-child) {
    display: block;
    /* margin-inline-end: 2rem; */
    margin-bottom: 2rem;
  }
  .custom-activeRadio .custom-radio .custom-radio .custom-control-label {
    color: #787878 !important;
    font-weight: 600;
    font-size: 16px;
    line-height: 17px;

    top: 5px !important;
    padding-inline-start: 16px !important;
  }
  .custom-activeRadio
    .custom-radio
    .custom-radio
    .custom-control-input:checked
    ~ .custom-control-label {
    color: #103f5e !important;
    font-weight: 700;
  }
}

.disabled-date-time {
  opacity: 0.5;
}
</style>
